export const examAdminAssetsCenter = {
  pageTitle: "Assets",
  pageSubtitle:
    "Manage uploaded assets in one place, with download, reference-safe deletion, and batch governance.",
  scopeGlobal: "Scope: Global assets (admin)",
  scopeMine: "Scope: My asset space ({username})",
  searchFilenamePlaceholder: "Search by filename/object key",
  searchContentTypePlaceholder: "Search by content type",
  createAction: "Upload asset",
  batchDeleteAction: "Batch delete",
  summaryTotal: "Total assets: {count}",
  summarySelected: "Selected assets: {count}",
  table: {
    filename: "Filename",
    contentType: "Type",
    sizeBytes: "Size (bytes)",
    referenceStatus: "Reference Status",
    uploadedAt: "Uploaded At",
  },
  labels: {
    inUse: "In use ({count})",
    notInUse: "Not in use",
  },
  messages: {
    uploadSuccess: "Asset upload succeeded",
    deleteSuccess: "Asset deleted",
    deleteBlocked: "Asset is referenced and cannot be deleted ({labels})",
    selectFileWarning: "Please select a file first",
  },
  confirm: {
    deleteTitle: "Delete this asset?",
    deleteDescription: "References are checked before deletion.",
    batchDeleteTitle: "Delete the selected assets in batch?",
    batchDeleteDescription:
      "The system checks references one by one. Referenced assets are skipped automatically with a prompt.",
    batchDeleteOkText: "Confirm delete",
  },
  drawer: {
    uploadTitle: "Upload asset",
    sceneLabel: "Scene identifier (optional)",
    scenePlaceholder: "Example: exam_attachment / question_material",
  },
};
